export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "97%", md: 320 },
  bgcolor: "background.paper",
  padding: "16px 20px",
  borderRadius: "8px",
  "&:focus-visible": {
    outline: "unset",
  },
};

export const header = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  "& .MuiSvgIcon-root": {
    cursor: "pointer",
  },
};

export const iconWrapper = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "12px",
};
